import { IAdvertisedCoursesRes } from "../../models/advertisedcourse.model";
import { ICreateAnnouncement, IAvailableCoureResponse, IAvailableCourse } from "../../models/trainee-course.model";
import deleteService from "../deleteService";
import getService from "../getService";
import postService from "../postService";
import putService from "../putService";



const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/" ;


class ProgramService {
  async getPrograms(filter : string) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-courses${filter}`
    );
    return response.data;
  }
  async getModuleCourses(uuid : string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-courses/module/${uuid}/get-courses`
    );
    return response.data;
  }
  async getProgramModules(uuid : string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-courses/${uuid}/get-modules`
    );
    return response.data;
  }

  async getAProgram(id : string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-courses/${id}`
    );
    return response.data;
  }

  async addModuleToProgram(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}program-courses/add-module`, data);
    return response.data;
  }
  
  async updateProgramModule(data: any) {
    const response = await putService.put(`${CONFIG_API_URL}program-courses/add-module`, data); 
    return response.data;
  }
    
  async updateProgramModuleStatus(data: any, uuid:string) {
    const response = await putService.put(`${CONFIG_API_URL}program-courses/update-module/${uuid}`, data); 
    return response.data;
  }
 
  async addCourseToProgramModule(data: any, uuid:string) {
    const response = await postService.post(`${CONFIG_API_URL}program-courses/module/${uuid}/add-course`, data); 
    return response.data;
  }

  async removeCourseFromProgramModule(data: any,uuid:string) {
    const response = await postService.post(`${CONFIG_API_URL}program-courses/module/${uuid}/remove-course`, data); 
    return response.data;
  }
  async createDiscipline(data : any) {
    const response = await postService.post(`${CONFIG_API_URL}program-data/disciplines`, data);
    
    return response.data;
  }
  async getDisciplines() {
    const response = await getService.get(`${CONFIG_API_URL}program-data/disciplines`);
    
    return response.data;
  }

  async traineeChangeDisciplineSpecialization(data: {admission_code: string, program_discipline_id: string, program_specialization_id: string}){
    const response = await postService.post(`${CONFIG_API_URL}courses/trainee-change-discipline-specialization`, data);
    
    return response.data;
  }

  async deleteDiscipline(uuid : any) {
    const response = await deleteService.delete(`${CONFIG_API_URL}program-data/disciplines/${uuid}`);
    return response.data;
  }
  async getProgramDisciplines(uuid : string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-courses/${uuid}/get-disciplines`
    );
    return response.data;
  }
  async addDisciplineToProgram(uuid : string | undefined,data: any) {
    const response = await postService.post(`${CONFIG_API_URL}program-courses/${uuid}/add-discipline`, data);
    return response.data;
  }
  async deleteProgramDiscipline(program_id : any, program_discipline_id : any) {
    const response = await deleteService.delete(`${CONFIG_API_URL}program-courses/${program_id}/delete-discipline/${program_discipline_id}`);
    return response.data;
  }
  async createSpecialization(data : any) {
    const response = await postService.post(`${CONFIG_API_URL}program-data/specializations`, data); 
    return response.data;
  }
  async getSpecializations() {
    const response = await getService.get(`${CONFIG_API_URL}program-data/specializations`); 
    return response.data;
  }
  async deleteSpecialization(uuid : any) {
    const response = await deleteService.delete(`${CONFIG_API_URL}program-data/specializations/${uuid}`);
    return response.data;
  }
  async getProgramSpecialization(uuid : string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}program-courses/${uuid}/get-specializations`
    );
    return response.data;
  }
  async addSpecializationToProgram(uuid : string | undefined,data: any) {
    const response = await postService.post(`${CONFIG_API_URL}program-courses/${uuid}/add-specializations`, data);
    return response.data;
  }
  async deleteProgramSpecialization(program_id : any, program_special_id : any) {
    const response = await deleteService.delete(`${CONFIG_API_URL}program-courses/${program_id}/delete-discipline/${program_special_id}`);
    return response.data;
  }

 
  
}
export default new ProgramService();
